




















import { Component, Vue } from 'vue-property-decorator';
import { navigationGroups } from '@/router';
import NavigationGroup from '@/models/navigationGroup';
import NavigationRoute from '@/models/navigationRoute';

@Component({})
export default class RouteList extends Vue {
  private navigationGroups: NavigationGroup[] = navigationGroups;

  goToRoute(route: NavigationRoute){
    if(this.$router.currentRoute.name == route.routeName){
      return;
    }

    this.$router.push({ name: route.routeName });
    this.$emit("onRouteSelected");
  }
}
